import type {
  CatalogProviderLoaderResult,
  CatalogProviderSummary
} from '@/features/catalog';
import { getProviderProfileUrl } from '@paction-2.0/util';
import {
  formatCurrency,
  formatDateLabel,
  hasMorePages as hasMorePagesGeneric
} from '@/lib/format';

export { formatCurrency };

export const formatAvailabilityLabel = (
  listing: CatalogProviderSummary['listings'][number]
) => {
  if (listing.isAvailableNow) {
    return 'Available now';
  }
  const formatted = formatDateLabel(listing.availableDate ?? undefined);
  return formatted ? `Ready ${formatted}` : undefined;
};

export const formatPriceRange = (min?: number | null, max?: number | null) => {
  if (
    typeof min === 'number' &&
    Number.isFinite(min) &&
    typeof max === 'number' &&
    Number.isFinite(max)
  ) {
    if (min === max) {
      return formatCurrency(min);
    }
    return `${formatCurrency(min)} - ${formatCurrency(max)}`;
  }
  if (typeof min === 'number' && Number.isFinite(min)) {
    return formatCurrency(min);
  }
  if (typeof max === 'number' && Number.isFinite(max)) {
    return formatCurrency(max);
  }
  return undefined;
};

export const providerHref = (provider: CatalogProviderSummary) => {
  const url = getProviderProfileUrl({
    slug: provider.slug,
    address: provider.provinceSlug
      ? {
          state: provider.provinceSlug
        }
      : undefined
  });

  if (!url) {
    throw new Error('providerHref: missing provider slug for profile URL');
  }

  return url;
};

export const hasMorePages = (
  pagination: CatalogProviderLoaderResult['pagination']
) => hasMorePagesGeneric(pagination);
